export const LANGUAGES = {
  am: 'am',
  it: 'it',
  en: 'en',
};
